export default __webpack_public_path__ + "static/media/Flag_of_Norway.852e6c61.svg";